import React, { useEffect, useMemo, useState } from 'react'
import Heading from './template/Heading'
import Description from './template/Description'
import GotoEndpoint from './template/GotoEndpoint'
import SectionHeading from './template/SectionHeading'
import SectionBlock from './template/SectionBlock'
import { FEATURED_ITEMS } from '@/content/siteContent'

function Feature() {
    const [activeIndex, setActiveIndex] = useState(0)

    useEffect(() => {
        const intervalId = window.setInterval(() => {
            setActiveIndex((currentIndex) => (currentIndex + 1) % FEATURED_ITEMS.length)
        }, 4500)

        return () => window.clearInterval(intervalId)
    }, [])

    const activeItem = useMemo(() => FEATURED_ITEMS[activeIndex], [activeIndex])

    return (
        <SectionBlock key={"feature"} className="grid-cols-1 gap-10 py-12 pb-12 lg:grid-cols-3 lg:gap-12 lg:pb-20 ">
            <div className='col-span-1 flex flex-col items-start justify-between  lg:gap-8 h-full pb-2 text-center sm:text-left  '>
                {/* tagline */}
                <div className='w-full '>
                    <SectionHeading number='01' content="Featured Work" className="justify-center lg:justify-start pb-6 lg:pb-10 " />

                    <div key={activeItem?.id} className='space-y-4 transition-all duration-700 ease-out'>
                        <Heading className='mx-auto lg:mx-0 text-center lg:text-left max-w-[16ch] sm:max-w-[14ch] md:max-w-[12ch] '>
                            {activeItem?.title}
                        </Heading>
                        <Description className=' w-full max-w-xl leading-7 sm:text-lg lg:mx-0 lg:w-4/5 mx-auto text-center lg:text-left text-secondary'>
                            {activeItem?.description}
                        </Description>
                    </div>
                </div>
                <div className='self-center lg:self-auto'>
                    <GotoEndpoint key={activeItem?.id} content={activeItem?.linkLabel ?? ""} endpoint={activeItem?.endpoint ?? "#"} className='inline-flex items-center sm:text-lg' />
                </div>
            </div>
            <div className='lg:col-span-2 rounded-lg bg-accent/10 pl-2 sm:pl-3 lg:pl-4 pt-2 sm:pt-3 lg:pt-4 relative'>
                {/* crousal */}
                <div className='relative isolate flex min-h-[16rem] w-full overflow-hidden rounded-lg bg-secondary/20 sm:min-h-[20rem] lg:min-h-[28rem] 2xl:min-h-[32rem]'>
                    {FEATURED_ITEMS.map((item, index) => (
                        <img loading="lazy"
                            key={item.id}
                            src={item.image}
                            alt={item.imageAlt}
                            className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-700 ease-in-out ${index === activeIndex ? 'opacity-100' : 'opacity-0'}`}
                        />
                    ))}

                    {/* <div className='pointer-events-none absolute inset-x-0 bottom-0 h-28 bg-gradient-to-t from-primary/45 to-transparent' />
                        <div className='absolute inset-x-0 bottom-0 flex items-end justify-between gap-4 p-4 sm:p-6'>
                            <div>
                                <p className='text-xs uppercase tracking-[0.45em] text-base/80 sm:text-sm'>
                                    {activeItem.label}
                                </p>
                                <p className='mt-2 text-lg font-semibold text-base sm:text-2xl'>
                                    {activeItem.title}
                                </p>
                        </div>
                    </div> */}
                </div>
                <div className='mt-4 flex flex-wrap items-center justify-center gap-3 py-2 text-sm sm:text-xl font-semibold tracking-[0.25em]  lg:justify-end absolute text-secondary -bottom-14 right-0 z-[29] '>
                    {FEATURED_ITEMS.map((item, index) => {
                        const isActive = index === activeIndex

                        return (
                            <button
                                key={item.id}
                                type='button'
                                onClick={() => setActiveIndex(index)}
                                aria-label={`Show ${item.title}`}
                                aria-pressed={isActive}
                                className={`cursor-pointer transition-all duration-300 ${isActive
                                    ? 'text-accent'
                                    : 'hover:text-accent'
                                    }`}
                            >
                                {String(index + 1).padStart(2, '0')}
                            </button>
                        )
                    })}
                </div>
            </div>

        </SectionBlock>
    )
}

export default Feature
